import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { authApi } from "../../api";
import AdminSpinner from "../components/AdminSpinner";
import usePageReady from "../../shared/usePageReady";
import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";
import Footer from "../components/Footer";

const metadata = {
    title: `Email Verification || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function VerifyEmailPage({ onPageReady }) {
    usePageReady(onPageReady);

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const [status, setStatus] = useState("loading"); // loading | success | error

    const navigate = useNavigate();

    // VERIFY EMAIL
    useEffect(() => {
        const verify = async () => {
            try {
                const res = await authApi.verifyEmail(token);

                if (res?.data?.message === "Email successfully verified") {
                    setStatus("success");
                } else {
                    setStatus("error");
                }
            } catch (_err) {
                setStatus("error");
            }
        };

        if (token) verify();
        else setStatus("error");
    }, [token]);

    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />

            {/* Breadcrumb */}
            <div className="tf-breadcrumb">
                <div className="container">
                    <ul className="breadcrumb-list">
                        <li className="item-breadcrumb">
                            <Link to="/" className="text">Home</Link>
                        </li>
                        <li className="item-breadcrumb dot">
                            <span />
                        </li>
                        <li className="item-breadcrumb">
                            <span className="text">Email Verification</span>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Page Title */}
           

            {/* MAIN CONTENT */}
            <div className="container py-5 text-center">
                {status === "loading" && (
                    <>
                        <AdminSpinner />
                        <p className="mt-3">Verifying your email...</p>
                    </>
                )}

                {status === "success" && (
                    <>
                        <h2 className="mb-3">Email Verified Successfully 🎉</h2>
                        <p>Your email address has been verified. You can now use all features.</p>

                        <button
                            className="tf-btn animate-btn mt-4"
                            onClick={() => navigate("/account-page")}
                        >
                            Go to My Account
                        </button>
                    </>
                )}

                {status === "error" && (
                    <>
                        <h2 className="mb-3">
                            Email Verification Failed ❌
                        </h2>
                        <p>The verification link is invalid or expired.</p>

                        <Link to="/" className="tf-btn animate-btn mt-4">
                            Go to Home
                        </Link>
                    </>
                )}
            </div>

            <Footer />
        </>
    );
}
